import React from 'react';
import './error-indicator.css';

const ErrorIndicator = () => {
  return (
    <main className="main">
      <div className="error-indicator">
        Что то пошло не так... <br /> Мы знаем о проблеме и уже работаем. <br />{' '}
        Попробуйте обновить страницу или зайти попозже
      </div>
    </main>
  );
};

export default ErrorIndicator;
